
import { Action } from '@ngrx/store';
import { DependantDetails } from '../../model/ngrx/dependant-details.model';
import * as DepDetailsActions from './../actions/dependant-details.actions';

export type Actions = DepDetailsActions.Actions;

const initialState: DependantDetails = {
    dateOfBirth: '',
    gender: '',
    relationship: '',
    dependantQuestion: '',
    riskAndStaticQuestion:[]
};

export function depDetailsReducer(state: DependantDetails[] = [], action: DepDetailsActions.Actions) {
    switch (action.type) {
        case DepDetailsActions.ADD_DEPENDANT_DETAILS:
            return [...state, action.payload];
        case DepDetailsActions.REMOVE_DEPENDANT_DETAILS:
            state = [];
            return state;

        default:
            return state;
    }
}
